exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".campaign-footer{width:100%;background-color:#026e9f;color:#fff;bottom:0;margin-top:10px}.campaign-footer a,.campaign-footer a:hover,.campaign-footer a:visited{color:#fff}.campaign-footer p,.campaign-footer ul{padding:0;margin:0}.is-csx .use-sticky-footer .footer{display:table-row;height:1px;background-color:#026e9f;color:#fff}.list-inline-bullets>li:after{content:\"\\2022\";margin:0 0 0 10px}.list-inline-bullets>li:last-child:after{content:\"\";margin:0}.campaign-footer .container{padding:30px 15px}", ""]);

// exports
